import './dashboard/vi-dashboard';
import './builder/ai-builder-dashboard';

export class OldDashboard {
  readonly id = 'old/dashboard/index';
  readonly crate = 'old/dashboard';
  readonly ns = 'old';
}

export default new OldDashboard();
